import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Density = 'comfortable' | 'dense';
type Canvas = 'light' | 'dark';

interface UIState {
  density: Density;
  canvas: Canvas;
  sidebarCollapsed: boolean;
  setDensity: (d: Density) => void;
  setCanvas: (c: Canvas) => void;
  setSidebarCollapsed: (b: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      density: 'comfortable',
      canvas: 'light',
      sidebarCollapsed: false,
      setDensity: (density) => set({ density }),
      setCanvas: (canvas) => set({ canvas }),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
    }),
    { name: 'msm-ui' },
  ),
);
